var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: "创建菜单",
            "close-on-click-modal": false,
            width: "1000px",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "inputForm",
              attrs: {
                size: "small",
                model: _vm.inputForm,
                "label-width": "120px",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.doSubmit()
                },
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "上级菜单",
                    prop: "parent.id",
                    rules: [
                      {
                        required: true,
                        message: "请选择上级菜单",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("SelectTree", {
                    ref: "menuParentTree",
                    attrs: {
                      props: {
                        value: "id", // ID字段名
                        label: "name", // 显示名称
                        children: "children", // 子级字段名
                      },
                      data: _vm.menuList,
                      value: _vm.inputForm.parent.id,
                      clearable: true,
                      accordion: true,
                    },
                    on: {
                      getValue: function (value) {
                        _vm.inputForm.parent.id = value
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "名称",
                    prop: "name",
                    rules: [
                      {
                        required: true,
                        message: "名称不能为空",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "200", placeholder: "菜单名称" },
                    model: {
                      value: _vm.inputForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputForm, "name", $$v)
                      },
                      expression: "inputForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm.inputForm.type !== "2"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "菜单图标", prop: "icon" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          readonly: true,
                          placeholder: "菜单图标名称",
                        },
                        on: { focus: _vm.selectIcon },
                        model: {
                          value: _vm.inputForm.icon,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "icon", $$v)
                          },
                          expression: "inputForm.icon",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("data-rule-list", {
                ref: "dataRuleList",
                attrs: { form: _vm.form },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.doSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Icon", {
        ref: "icon",
        on: {
          getValue: function (value) {
            return (_vm.inputForm.icon = value)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }